import { requestScrollAnimation } from '../util/request-animation';

const initStickyHeader = () => {
  const siteHeader = document.querySelector('.shopify-section--site-header');
  const landingHero = document.querySelector('.shopify-section--hero');
  let offset = (landingHero) ? landingHero.clientHeight : 0;
  console.log(offset);

  const checkStickyHeader = () => {
    if(!window.flags.pauseScrolling) {
      if(window.util.scrollingDown || window.util.scrollY <= offset) {
        siteHeader.classList.remove('show');
      } else {
        siteHeader.classList.add('show');
      }
    }
  }
  requestScrollAnimation(checkStickyHeader);
};

export { initStickyHeader };